import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import ModalDialogContext from "./ModalDialogContext";

export class ModalDialogProvider extends Component {
  showModalDialog = (e) => {
    const {
      title,
      loading,
      message,
      onPressOk,
      onPressYes,
      onPressNo,
      onPressCancel,
      status,
      yesLabel = this.props.t("labels.common.yes"),
      noLabel = this.props.t("labels.common.no"),
    } = e || {};

    this.setState({
      visible: true,
      title,
      message,
      onPressOk,
      onPressYes,
      onPressNo,
      onPressCancel,
      loading,
      status,
      yesLabel,
      noLabel,
    });
  };

  hideModalDialog = () => {
    this.setState({
      visible: false,
      title: "",
      message: "",
      onPressOk: null,
      onPressYes: null,
      onPressNo: null,
      onPressCancel: null,
      loading: false,
      yesLabel: "",
      noLabel: "",
    });
  };

  showMessage = (params) => {
    const { title = this.props.t("labels.common.dialog.success"), message } =
      params || {};
    this.showModalDialog({
      title: title,
      message: message,
      loading: false,
      onPressOk: this.hideModalDialog,
    });
  };

  showConfirmation = (params) => {
    const {
      title = this.props.t("labels.common.dialog.confirm"),
      message,
      onPressYes,
      yesLabel,
      noLabel,
    } = params || {};
    this.showModalDialog({
      title: title,
      message: message,
      loading: false,
      yesLabel,
      noLabel,
      onPressYes: () => {
        this.hideModalDialog();
        onPressYes();
      },
      onPressNo: this.hideModalDialog,
    });
  };

  showErrorMessage = (params) => {
    const { message, error } = params || {};
    const { graphQLErrors } = error || {};

    let errMsg = message;
    let title = this.props.t("labels.common.dialog.error");
    if (graphQLErrors && graphQLErrors.length > 0) {
      errMsg = graphQLErrors[0].message;
      if (
        graphQLErrors[0].extensions &&
        graphQLErrors[0].extensions.apiErrorCode
      ) {
        title = graphQLErrors[0].extensions.apiErrorCode;
      }
    }

    if (!errMsg && error) {
      errMsg = error.message;
    }
    this.showModalDialog({
      title: this.props.t(title),
      message: this.props.t(errMsg),
      loading: false,
      status: this.props.t("labels.common.dialog.failure"),
      onPressOk: this.hideModalDialog,
    });
  };

  showLoadingMessage = (params) => {
    const { title, message } = params || {};
    this.showModalDialog({
      title: this.props.t(title),
      message: this.props.t(message),
      loading: true,
      onPressOk: this.hideModalDialog,
    });
  };

  state = {
    visible: false,
    title: "",
    message: "",
    onPressOk: null,
    onPressYes: null,
    onPressNo: null,
    onPressCancel: null,
    loading: false,
    status: "",
    yesLabel: "",
    noLabel: "",
    showModalDialog: this.showModalDialog,
    hideModalDialog: this.hideModalDialog,
    showMessage: this.showMessage,
    showErrorMessage: this.showErrorMessage,
    showLoadingMessage: this.showLoadingMessage,
    showConfirmation: this.showConfirmation,
  };

  render() {
    return (
      <ModalDialogContext.Provider value={this.state}>
        {this.props.children}
      </ModalDialogContext.Provider>
    );
  }
}

export default withTranslation()(ModalDialogProvider);
